import request from '@/utils/request'
import { AxiosPromise } from 'axios'
import { LoginData, LoginResult, VerifyCodeResult, TenantInfo } from './types'
import { UserInfo } from '@/api/system/user/types'
import { param } from '@/utils'

// pc端固定客户端授权id
const clientId = import.meta.env.VITE_APP_CLIENT_ID

/**
 * @param data {LoginData}
 * @returns
 */
export function login(data: LoginData): AxiosPromise<LoginResult> {
  const params = {
    ...data,
    clientId: data.clientId || clientId,
    grantType: data.grantType || 'password'
  }
  return request({
    url: '/auth/login',
    headers: {
      isToken: false,
      isEncrypt: true
    },
    method: 'post',
    data: params
  })
}

// 注册方法
export function register(data: any) {
  return request({
    url: '/auth/localRegister',
    headers: {
      isToken: false,
      isEncrypt: false,
      "Content-Type": "multipart/form-data"
    },
    method: 'post',
    data
  })
}
// 获取内部企业列表
export function getInnerComps() {
  const param = {
    "action": "innerSystemOrg"
  }
  return request({
    url: '/unify/operate',
    headers: {
      isToken: false,
      isEncrypt: false,
    },
    method: 'post',
    data:param
  })
}

/**
 * 注销
 */
export function logout() {
  const params = {
    "action": "logout"
  }
  return request({
    url: '/unify/operate',
    method: 'post',
    data: params
  })
}

/**
 * 获取验证码
 */
export function getCodeImg(): AxiosPromise<VerifyCodeResult> {
  return request({
    url: '/auth/code',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

/**
 * 第三方登录
 */
export function callback(data: LoginData): AxiosPromise<any> {
  const LoginData = {
    ...data,
    clientId: clientId,
    grantType: 'social'
  }
  return request({
    url: '/auth/social/callback',
    method: 'post',
    data: LoginData
  })
}

// 获取用户详细信息
export function getInfo(): AxiosPromise<UserInfo> {
  const params = {
    "action": "userInfo"          // 操作类型
  }
  return request({
    url: '/unify/operate',
    method: 'post',
    data: params
  })
}

// 获取租户列表
export function getTenantList(): AxiosPromise<TenantInfo> {
  return request({
    url: '/auth/tenant/list',
    headers: {
      isToken: false
    },
    method: 'get'
  })
}
// 获取用户详细信息
export function getKey() {
  const params = {
    "action": "client"          // 操作类型
  }
  return request({
    url: '/unify/operate',
    method: 'post',
    data: params
  })
}